// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"confirm-modal_Wrapper__Iteak","Title":"confirm-modal_Title__6Pu1n","Description":"confirm-modal_Description__Gg54S"};